import { render, staticRenderFns } from "./Internal-Note-Attachment-Detail.vue?vue&type=template&id=516da882"
import script from "./Internal-Note-Attachment-Detail.vue?vue&type=script&lang=js"
export * from "./Internal-Note-Attachment-Detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports